import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  modalSection: {
    paddingBottom: "1.5rem",
    width: "100%",
  },
}));

export default styles;
